import styled from '@emotion/styled';
import { Text } from '@innovationdepartment/proxima-ui';
import { AUDIENCES_GETTING_STARTED_URL } from 'constants/urls';
import React from 'react';
import ProximaLink from 'ui/ProximaLink';
import SeedAudiencesTableEmptyContentSteps from './SeedAudiencesTable.EmptyContentSteps';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px;
`;

const TextWrapper = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  max-width: 720px;
  gap: ${({ gap = 16 }) => gap}px;
`;

const SeedAudiencesTableEmptyContent = () => (
  <ContentWrapper>
    <TextWrapper>
      <Text variant="h4" color="neutral80">
        Create your first audience
      </Text>
      <Text variant="body1Semibold" color="neutral60">
        Build high-performing lookalikes to target people most likely to purchase, unlock more
        efficient advertising spend, and scale ads profitably.
      </Text>
    </TextWrapper>
    <SeedAudiencesTableEmptyContentSteps />
    <Text variant="body2" color="neutral60">
      <ProximaLink to={AUDIENCES_GETTING_STARTED_URL}>Learn more</ProximaLink>&nbsp;about how to use
      Proxima audiences.
    </Text>
  </ContentWrapper>
);

export default React.memo(SeedAudiencesTableEmptyContent);
